import { BoxIcon } from '#atoms';
import { IconClose } from '#atoms/Icon/icons';
import { useUserInfo } from '#providers/UserInfo';

import { Link } from 'react-router-dom';

const SettingsMenu = () => {
  const { userInfo } = useUserInfo();

  return (
    <div className="flex flex-col gap-24">
      <div className="flex items-center px-20 py-20 justify-between border-b-1 border-solid border-[#2E2B36]">
        <div className="flex items-center gap-8">
          <img
            src={userInfo?.profile[0]?.resizedLink}
            className="w-24 h-24 rounded-full"
          />{' '}
          <span>{userInfo?.name} 트레이너님</span>
        </div>
        <Link to="/profile">
          <IconClose width={24} height={24} />
        </Link>
      </div>
      <div className="flex flex-col gap-32 justify-between p-20 pt-0">
        {NAVIGATE.map(value => {
          return (
            <Link
              key={value.to}
              className="flex items-center justify-between py-8 text-[#EAE8ED]"
              to={value.to}
              target={value.target}
            >
              {value.label}
              <BoxIcon type="next-arrow" onlyIcon size={14} />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

const NAVIGATE = [
  { to: 'account', label: '계정 관리', target: '' },
  { to: 'alarm', label: '알림 설정', target: '' },
  { to: 'billing', label: '수업 정산', target: '' },
  {
    to: 'https://fibud.notion.site/16fdbe9b1a2b802d95e8cbef80ddf221',
    label: '공지사항',
    target: '_blank'
  },
  {
    to: 'https://slashpage.com/fibudtrainer',
    label: '피벗 가이드',
    target: '_blank'
  },
  {
    to: 'http://pf.kakao.com/_cxeCPG',
    label: '카카오톡 고객센터',
    target: '_blank'
  }
];

export default SettingsMenu;
